/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SlotDto } from '../model';
/**
 * YardBlockSlotsApi - axios parameter creator
 */
export const YardBlockSlotsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {string} [yardBlockBayId] 
         * @param {string} [yardBlockRowId] 
         * @param {number} [tier] 
         * @param {boolean} [isOccupied] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotsGet: async (yardBlockId?: string, yardBlockBayId?: string, yardBlockRowId?: string, tier?: number, isOccupied?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockSlots/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockId !== undefined) {
                localVarQueryParameter['YardBlockId'] = yardBlockId;
            }

            if (yardBlockBayId !== undefined) {
                localVarQueryParameter['YardBlockBayId'] = yardBlockBayId;
            }

            if (yardBlockRowId !== undefined) {
                localVarQueryParameter['YardBlockRowId'] = yardBlockRowId;
            }

            if (tier !== undefined) {
                localVarQueryParameter['Tier'] = tier;
            }

            if (isOccupied !== undefined) {
                localVarQueryParameter['IsOccupied'] = isOccupied;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockSlotId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotsSetLockStatus: async (yardBlockSlotId?: string, lockStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockSlots/SetLockStatus/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockSlotId !== undefined) {
                localVarQueryParameter['yardBlockSlotId'] = yardBlockSlotId;
            }

            if (lockStatus !== undefined) {
                localVarQueryParameter['lockStatus'] = lockStatus;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlockSlotsApi - functional programming interface
 */
export const YardBlockSlotsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlockSlotsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {string} [yardBlockBayId] 
         * @param {string} [yardBlockRowId] 
         * @param {number} [tier] 
         * @param {boolean} [isOccupied] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockSlotsGet(yardBlockId?: string, yardBlockBayId?: string, yardBlockRowId?: string, tier?: number, isOccupied?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockSlotsGet(yardBlockId, yardBlockBayId, yardBlockRowId, tier, isOccupied, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockSlotsApi.yardBlockSlotsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockSlotId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockSlotsSetLockStatus(yardBlockSlotId?: string, lockStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockSlotsSetLockStatus(yardBlockSlotId, lockStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockSlotsApi.yardBlockSlotsSetLockStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlockSlotsApi - factory interface
 */
export const YardBlockSlotsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlockSlotsApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlockSlotsApiYardBlockSlotsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotsGet(requestParameters: YardBlockSlotsApiYardBlockSlotsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlotDto>> {
            return localVarFp.yardBlockSlotsGet(requestParameters.yardBlockId, requestParameters.yardBlockBayId, requestParameters.yardBlockRowId, requestParameters.tier, requestParameters.isOccupied, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockSlotsApiYardBlockSlotsSetLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotsSetLockStatus(requestParameters: YardBlockSlotsApiYardBlockSlotsSetLockStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlotDto>> {
            return localVarFp.yardBlockSlotsSetLockStatus(requestParameters.yardBlockSlotId, requestParameters.lockStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlockSlotsGet operation in YardBlockSlotsApi.
 */
export interface YardBlockSlotsApiYardBlockSlotsGetRequest {
    readonly yardBlockId?: string

    readonly yardBlockBayId?: string

    readonly yardBlockRowId?: string

    readonly tier?: number

    readonly isOccupied?: boolean
}

/**
 * Request parameters for yardBlockSlotsSetLockStatus operation in YardBlockSlotsApi.
 */
export interface YardBlockSlotsApiYardBlockSlotsSetLockStatusRequest {
    readonly yardBlockSlotId?: string

    readonly lockStatus?: boolean
}

/**
 * YardBlockSlotsApi - object-oriented interface
 */
export class YardBlockSlotsApi extends BaseAPI {
    /**
     * 
     * @param {YardBlockSlotsApiYardBlockSlotsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockSlotsGet(requestParameters: YardBlockSlotsApiYardBlockSlotsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockSlotsApiFp(this.configuration).yardBlockSlotsGet(requestParameters.yardBlockId, requestParameters.yardBlockBayId, requestParameters.yardBlockRowId, requestParameters.tier, requestParameters.isOccupied, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockSlotsApiYardBlockSlotsSetLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockSlotsSetLockStatus(requestParameters: YardBlockSlotsApiYardBlockSlotsSetLockStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockSlotsApiFp(this.configuration).yardBlockSlotsSetLockStatus(requestParameters.yardBlockSlotId, requestParameters.lockStatus, options).then((request) => request(this.axios, this.basePath));
    }
}

